import { api } from './api.js'

/**
 * POST /v2/sessions
 * { session: { email, password, type: 3 } }
 * Returns user object with auth_token, company, chain, etc.
 * Handles both wrapped { user: {...} } and unwrapped responses.
 */
export async function login(email, password) {
  const data = await api.post('/v2/sessions', {
    session: { email, password, type: 3 },
  })
  // AMS may return { "user": {...} } or the object directly
  return data?.user || data
}

/**
 * DELETE /v2/sessions/:token
 */
export async function logout(token) {
  try {
    await api.del(`/v2/sessions/${token}`)
  } catch {
    // ignore errors on logout
  }
}
